import { useEffect, useMemo } from 'react';

import { useOrganizations } from './useOrganizations';
import { useCurrentOrganizationStore } from '../store/useCurrentOrganizationStore';

export function useOrganizationsState() {
    const organizationsQuery = useOrganizations();
    const currentOrganizationId = useCurrentOrganizationStore((state) => state.currentOrganizationId);
    const setCurrentOrganizationId = useCurrentOrganizationStore((state) => state.setCurrentOrganizationId);

    useEffect(() => {
        if (!organizationsQuery.data) {
            return;
        }

        if (organizationsQuery.data.length === 0) {
            if (currentOrganizationId !== null) {
                setCurrentOrganizationId(null);
            }
            return;
        }

        const hasCurrentOrganization = organizationsQuery.data.some(
            (organization) => organization.id === currentOrganizationId
        );

        if (!hasCurrentOrganization) {
            setCurrentOrganizationId(organizationsQuery.data[0].id);
        }
    }, [currentOrganizationId, organizationsQuery.data, setCurrentOrganizationId]);

    const currentOrganization = useMemo(() => {
        if (!organizationsQuery.data || !currentOrganizationId) {
            return null;
        }

        return organizationsQuery.data.find((organization) => organization.id === currentOrganizationId) ?? null;
    }, [currentOrganizationId, organizationsQuery.data]);

    return {
        organizations: organizationsQuery.data ?? [],
        currentOrganization,
        currentOrganizationId,
        isPending: organizationsQuery.isPending,
        isError: organizationsQuery.isError,
        isSuccess: organizationsQuery.isSuccess,
        error: organizationsQuery.error instanceof Error ? organizationsQuery.error : null
    };
}
